import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { css } from "styled-components";

logoStyles.wrapper = {
    css: css`
        max-width: 150px;
        max-height: auto;
        display: flex;
        align-items: center;
        span {
            display: flex !important;
        }
    `,
};
